/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aware_Mild_Newt_EvokeInputs */

const fr_aware_mild_newt_evoke = /** @type {(inputs: Aware_Mild_Newt_EvokeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connecte toi à ton compte`)
};

/**

* @param {Aware_Mild_Newt_EvokeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const aware_mild_newt_evoke = /** @type {((inputs?: Aware_Mild_Newt_EvokeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aware_Mild_Newt_EvokeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_aware_mild_newt_evoke(inputs)
});